export enum DATASET_TYPE {
  CARTESIAN = "cartesian",
  FILE = "file",
  FORM = "form",
  GPS = "gps",
  IMAGE = "image",
  PLAN_POSITIONING = "planPositioning",
}
